import axios from "axios";
import React, { useEffect, useState } from "react";
import Select, {createFilter} from "react-select";
import {getUserViewAllSettingsTerminalApi, getUserViewListApi} from "../Api";
import Transfer from "./Transfer";
import ViewSettingOptions from "./ViewSettingOptions";
import CustomOption from "../Utils/CustomOption";
import CustomMenuList from "../Utils/CustomMenuList";

function ViewSettings() {
  const loggedUserStorage = sessionStorage.getItem('loggedUserStorage');
  const [activeTab, setActiveTab] = useState(1);
  const [selectedUserViewSettings, setSelectedUserViewSettings] = useState();
  const [userViewSettingsOptions, setUserViewSettingsOptions] = useState([]);
  const [selectedUserForApi, setSelectedUserForApi] = useState("");
  const [filterValue,setFilterValue] = useState("copy")
  const [copyValue,setCopyValue] = useState()
    const [pending, setPending] = React.useState(true);
  const tabs = ["columns", "Options"];
  const renderTab = () => {
    if (activeTab == 1) {
      return <Transfer viewID={selectedUserViewSettings} />;
    } else {
      return <ViewSettingOptions/>;
    }
  };
  const handleDefaultClick = () => {
    setSelectedUserForApi(selectedUserViewSettings);
  };

    const handleSettingsSelection = async (e) => {
        console.log(" ---- on change click ",e)
        setSelectedUserViewSettings(e)
    };
  useEffect(() => {
    const fetchUser = async () => {
      const result = await axios.get(`${getUserViewAllSettingsTerminalApi}?paramUserID=${loggedUserStorage}&paramUserViewID=-1&paramLoadAtStartUp=-1`);
      result?.data?.response.map((item, index) =>
        setUserViewSettingsOptions((old) => [
          ...old,
          { label: item?.userViewName, value: item?.userViewID },
        ])
      );
        setPending(false)
    };

    fetchUser();
    return () => {
      setUserViewSettingsOptions([]);
    };
  }, [selectedUserViewSettings]);
  const handleSaveViewClick = async()=>{
    // call the api to save view
  }

    if(pending){
        return <div className="spinner-container">
            <div className="loading-spinner">
            </div>
        </div>
    }
  return (
    <div className="mt-4">
      <form>
        <div class="form-group form-inline">
          <label for="exampleInputEmail1">
            Select pre-defined view setting to view terminals:
          </label>
          <div class="input-group ml-2">
            <Select
                filterOption={createFilter({ ignoreAccents: false })}
                captureMenuScroll={false}
                classNamePrefix="custom-select"
                components={{ Option: CustomOption, MenuList: CustomMenuList }}
              options={userViewSettingsOptions}
              value={selectedUserViewSettings}
                onChange={handleSettingsSelection}
              styles={{
                container: (provided) => ({
                  ...provided,
                  flex: 1,
                  width: "13vw",
                }),
              }}
            />
            <span
              class="input-group-text ml-2"
              role="button"
              onClick={handleDefaultClick}
            >
              Set as a Default
            </span>
          </div>
        </div>
      </form>
      {/*  */}
      <div className="row align-items-center">
        <div className="col col-md-8">
          <div class="form-check form-check-inline">
            <input
              class="form-check-input"
              type="radio"
              name="filter"
              value="copy"
              id="copy"
              onChange={(e)=>setFilterValue(e.target.value)}
              checked={filterValue == "copy" ? true : false}
            />
            <label class="form-check-label" htmlFor="copy">
              Copy view as:
            </label>
            <div>
              <div class="input-group ml-5">
                <input name="copyinput" onChange={e=>setCopyValue(e.target.value)} value={copyValue}/>
                <span
                  class="input-group-text ml-2"
                  role="button"
                  onClick={() => handleSaveViewClick()}
                >
                  Save view
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="col col-md-4">
          <div class="form-check form-check-inline">
            <input
              class="form-check-input"
              type="radio"
              name="filter"
              value="update"
              id="update"
              onChange={(e) =>setFilterValue(e.target.value)}
              checked={filterValue == "update" ? true : false}
            />
            <label class="form-check-label" htmlFor="update">
              Update
            </label>
          </div>
        </div>
      </div>
      {/*  */}
      <div className="mt-4">
        <ul className="nav nav-tabs nav-tabs-custom" role="tablist">
          {tabs.map((tab, index) => (
            <li className="nav-item">
              <a
                className={`nav-link ${index + 1 === activeTab && "active"}`}
                data-toggle="tab"
                href="#tb_terminal_mgmt"
                role="tab"
                onClick={() => setActiveTab(index + 1)}
              >
                <span className="d-block d-sm-none">
                  <i className="fas fa-address-card"></i>
                </span>
                <span
                  className="d-none d-sm-block"
                  style={{ whiteSpace: "pre-line" }}
                >
                  {tab}
                </span>
              </a>
            </li>
          ))}
        </ul>
        <div className="tab-pane mt-4" role="tabpanel">
          {renderTab()}
        </div>
      </div>
    </div>
  );
}

export default ViewSettings;
